import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home.vue'
import { locationLocales } from '@/documents/vpnHomeContent'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err)
}

const site = 'https://secureproxyvpn.com'
const canonical = (path) => `${site}${path}`
const locationRoutes = Object.entries(locationLocales).map(([localeKey, item]) => ({
	path: item.path,
	name: `${localeKey}-location`,
	meta: {
		appname: 'Secure VPN',
		localeKey,
		title: item.title,
		keywords: `Secure VPN ${item.label}`,
		description: item.description,
		link: [{ rel: 'canonical', href: canonical(item.path) }],
	},
	component: Home,
}))

export const constRoutesPc = [
	{
		path: '/',
		name: 'en-gb',
		meta: {
			appname: 'Secure VPN',
			title: 'Secure VPN Download - Fast, Private & Free VPN App',
			keywords: 'Secure VPN',
			description: 'Download Secure VPN App for fast, private, and reliable internet access. Enjoy secure browsing, stable connections, and easy VPN protection for your device.',
			link: [{ rel: 'canonical', href: canonical('/') }],
		},
		component: Home,
	},
	{
		path: '/blogs/',
		name: 'en-blog',
		meta: {
			appname: 'Secure VPN',
			title: 'Secure VPN Blogs | Streaming & platform alternatives',
			description:
				'Read Secure VPN blog articles about streaming platforms, movie site alternatives, and related viewing resources.',
			keywords: 'Secure VPN blogs, streaming alternatives, FMovies, MovieJoy, YesMovies',
			link: [{ rel: 'canonical', href: canonical('/blogs/') }],
		},
		component: () => import('@/views/blogIndex.vue'),
	},
	{
		path: '/blog/',
		redirect: '/blogs/',
	},
	{
		path: '/blog/fmovies-alternatives/',
		name: 'en-blog-fmovies-alternatives',
		meta: {
			appname: 'Secure VPN',
			blogSlug: 'fmovies-alternatives',
			title: 'FMovies Alternatives: Top 15 Streaming Options',
			description:
				'Check out 15 FMovies alternatives for watching movies and TV shows, including free platforms, subscription services, library options, and rentals.',
			keywords: 'FMovies alternatives, free movie streaming',
			link: [{ rel: 'canonical', href: canonical('/blog/fmovies-alternatives/') }],
		},
		component: () => import('@/views/blogArticle.vue'),
	},
	{
		path: '/blog/moviejoy-alternatives/',
		name: 'en-blog-moviejoy-alternatives',
		meta: {
			appname: 'Secure VPN',
			blogSlug: 'moviejoy-alternatives',
			title: 'MovieJoy Alternatives: 15 Streaming Platforms to Try',
			description:
				'Check out 15 MovieJoy alternatives for watching movies and TV shows, including free streaming platforms, subscription services, library resources, and rentals.',
			keywords: 'MovieJoy alternatives, streaming platforms',
			link: [{ rel: 'canonical', href: canonical('/blog/moviejoy-alternatives/') }],
		},
		component: () => import('@/views/blogArticle.vue'),
	},
	{
		path: '/blog/yesmovies-alternatives/',
		name: 'en-blog-yesmovies-alternatives',
		meta: {
			appname: 'Secure VPN',
			blogSlug: 'yesmovies-alternatives',
			title: 'YesMovies Alternatives: 15 Streaming Platforms to Consider',
			description:
				'Browse 15 YesMovies alternatives for movies and TV shows, with free streaming platforms, subscription services, library options, and digital rentals.',
			keywords: 'YesMovies alternatives, movie streaming',
			link: [{ rel: 'canonical', href: canonical('/blog/yesmovies-alternatives/') }],
		},
		component: () => import('@/views/blogArticle.vue'),
	},
	{
		path: '/blog/vpn-meaning/',
		name: 'en-blog-vpn-meaning',
		meta: {
			appname: 'Secure VPN',
			blogSlug: 'vpn-meaning',
			title: 'VPN Meaning: What Is a VPN and How Does It Work?',
			description:
				'What does VPN mean? Learn how a VPN works in simple terms, why people use one, and how it can help when browsing, traveling, or using public Wi-Fi.',
			keywords: 'VPN meaning, what is a VPN, Secure VPN',
			link: [{ rel: 'canonical', href: canonical('/blog/vpn-meaning/') }],
		},
		component: () => import('@/views/blogArticle.vue'),
	},
	{
		path: '/blog/activate-vpn-opera-browser/',
		name: 'en-blog-activate-vpn-opera-browser',
		meta: {
			appname: 'Secure VPN',
			blogSlug: 'activate-vpn-opera-browser',
			title: 'How to Activate VPN in Opera Browser on Desktop and Android',
			description:
				'Learn how to turn on VPN in Opera Browser on Windows, Mac, and Android. Follow simple steps to enable VPN, change your virtual location, and fix common problems.',
			keywords: 'Opera VPN, activate VPN Opera, Secure VPN',
			link: [{ rel: 'canonical', href: canonical('/blog/activate-vpn-opera-browser/') }],
		},
		component: () => import('@/views/blogArticle.vue'),
	},
	{
		path: '/blog/activate-vpn-uc-browser/',
		name: 'en-blog-activate-vpn-uc-browser',
		meta: {
			appname: 'Secure VPN',
			blogSlug: 'activate-vpn-uc-browser',
			title: 'How to Activate VPN in UC Browser on Android',
			description:
				'Learn how to turn on VPN in UC Browser on Android, find the VPN setting, choose a server, and fix common connection problems.',
			keywords: 'UC Browser VPN, Android VPN, Secure VPN',
			link: [{ rel: 'canonical', href: canonical('/blog/activate-vpn-uc-browser/') }],
		},
		component: () => import('@/views/blogArticle.vue'),
	},
	{
		path: '/download/',
		name: 'en-download',
		meta: {
			appname: 'Secure VPN',
			title: 'Download Secure VPN APK - Latest Version 2026',
			keywords: 'Secure VPN APK',
			description: 'Download Secure VPN APK Latest Version 2026 for Android and other devices. Enjoy fast, private, and secure VPN connections with optimized servers and easy one-tap access.',
			link: [{ rel: 'canonical', href: canonical('/download/') }],
		},
		component: () => import('@/views/download.vue'),
	},
	{
		path: '/about-us/',
		name: 'en-about',
		meta: {
			appname: 'Secure VPN',
			pageKey: 'about',
			title: 'About Us',
			description: 'Learn about Secure VPN, our mission, and how we provide information about VPN features, online privacy, and secure internet connections.',
			keywords: 'Secure VPN',
			link: [{ rel: 'canonical', href: canonical('/about-us/') }],
		},
		component: () => import('@/views/staticPage.vue'),
	},
	{
		path: '/contact-us/',
		name: 'en-contact',
		meta: {
			appname: 'Secure VPN',
			pageKey: 'contact',
			title: 'Contact Us - Support & Feedback',
			description: 'Contact Us for questions, feedback, or website-related inquiries. Our team is ready to help with information and support requests.',
			keywords: 'Secure VPN',
			link: [{ rel: 'canonical', href: canonical('/contact-us/') }],
		},
		component: () => import('@/views/staticPage.vue'),
	},
	{
		path: '/privacy-policy/',
		name: 'en-privacy',
		meta: {
			appname: 'Secure VPN',
			pageKey: 'privacy',
			title: 'Privacy Policy - Data Protection Information',
			description: 'Read the Privacy Policy to understand how we collect, use, and protect information while improving website experience.',
			keywords: 'Secure VPN',
			link: [{ rel: 'canonical', href: canonical('/privacy-policy/') }],
		},
		component: () => import('@/views/staticPage.vue'),
	},
	{
		path: '/terms-of-use/',
		name: 'en-terms',
		meta: {
			appname: 'Secure VPN',
			pageKey: 'terms',
			title: 'Terms of Use - Website Usage Rules',
			description: 'Review Secure VPN Terms of Use to understand website rules, user responsibilities, and conditions for accessing our content.',
			keywords: 'Secure VPN',
			link: [{ rel: 'canonical', href: canonical('/terms-of-use/') }],
		},
		component: () => import('@/views/staticPage.vue'),
	},
	{
		path: '/disclaimer/',
		name: 'en-disclaimer',
		meta: {
			appname: 'Secure VPN',
			pageKey: 'disclaimer',
			title: 'Secure VPN Disclaimer - Important Information',
			description: 'Read the Secure VPN Disclaimer for information about website content, third-party services, and user responsibilities.',
			keywords: 'Secure VPN',
			link: [{ rel: 'canonical', href: canonical('/disclaimer/') }],
		},
		component: () => import('@/views/staticPage.vue'),
	},
	{
		path: '/guides/',
		name: 'en-guides',
		meta: {
			appname: 'Secure VPN',
			title: 'Secure VPN Guides & Tutorials | Setup, Fixes & Tips',
			description:
				'Find step-by-step Secure VPN guides, including installation, setup, troubleshooting, speed optimization, connection fixes, and security tips for all devices.',
			keywords: 'Secure VPN',
			link: [{ rel: 'canonical', href: canonical('/guides/') }],
		},
		component: () => import('@/views/guides.vue'),
	},
	{
		path: '/for-pc/',
		name: 'en-for-pc',
		meta: {
			appname: 'Secure VPN',
			title: 'Secure VPN for PC Download | Windows VPN (2026)',
			description:
				'Download Secure VPN for PC and learn how to use it on Windows. Get better online privacy, secure browsing, and access websites safely with a VPN.',
			keywords: 'Secure VPN for PC',
			link: [{ rel: 'canonical', href: canonical('/for-pc/') }],
		},
		component: () => import('@/views/forPc.vue'),
	},
	{
		path: '/for-mac/',
		name: 'en-for-mac',
		meta: {
			appname: 'Secure VPN',
			title: 'Secure VPN Download for macOS \u2013 Free VPN for Mac',
			description:
				'Download Secure VPN for macOS and connect your Mac to a fast, private VPN. Learn how to install Secure VPN on Mac and protect your connection.',
			keywords: 'Secure VPN macOS, VPN for Mac, macOS VPN download, free VPN for Mac',
			link: [{ rel: 'canonical', href: canonical('/for-mac/') }],
		},
		props: { pageKey: 'mac' },
		component: () => import('@/views/platformPage.vue'),
	},
	{
		path: '/for-linux/',
		name: 'en-for-linux',
		meta: {
			appname: 'Secure VPN',
			title: 'Secure VPN Download for Linux \u2013 Free VPN for Linux',
			description:
				'Download Secure VPN for Linux and protect your internet connection with a private VPN. Get setup instructions and learn how to connect Secure VPN on Linux.',
			keywords: 'Secure VPN Linux, VPN for Linux, Linux VPN download, Secure VPN Ubuntu',
			link: [{ rel: 'canonical', href: canonical('/for-linux/') }],
		},
		props: { pageKey: 'linux' },
		component: () => import('@/views/platformPage.vue'),
	},
	{
		path: '/for-android/',
		name: 'en-for-android',
		meta: {
			appname: 'Secure VPN',
			title: 'Secure VPN Download for Android \u2013 Free VPN APK',
			description:
				'Download Secure VPN for Android and protect your mobile connection with a private VPN. Get the Android VPN app and follow the simple installation steps.',
			keywords: 'Secure VPN Android, Android VPN APK, VPN app for Android, Secure VPN APK',
			link: [{ rel: 'canonical', href: canonical('/for-android/') }],
		},
		props: { pageKey: 'android' },
		component: () => import('@/views/platformPage.vue'),
	},
	{
		path: '/for-ios/',
		name: 'en-for-ios',
		meta: {
			appname: 'Secure VPN',
			title: 'Secure VPN Download for iOS \u2013 Free VPN for iPhone & iPad',
			description:
				'Download Secure VPN for iOS and protect your iPhone or iPad connection. Set up a private VPN, choose a server, and connect in a few simple steps.',
			keywords: 'Secure VPN iOS, VPN for iPhone, VPN for iPad, iOS VPN download',
			link: [{ rel: 'canonical', href: canonical('/for-ios/') }],
		},
		props: { pageKey: 'ios' },
		component: () => import('@/views/platformPage.vue'),
	},
	{
		path: '/web-proxy/',
		name: 'en-web-proxy',
		meta: {
			appname: 'Secure VPN',
			title: 'Free Web Proxy Online: How It Compares to a Secure VPN',
			description:
				'Learn what a free web proxy is, how it works, and how it compares to a secure VPN. Explore the key differences, benefits, limitations, and the best option for your privacy.',
			keywords: 'free web proxy online',
			link: [{ rel: 'canonical', href: canonical('/web-proxy/') }],
		},
		component: () => import('@/views/webProxy.vue'),
	},
	{
		path: '/what-is-my-ip/',
		name: 'en-what-is-my-ip',
		meta: {
			appname: 'Secure VPN',
			title: 'What is my IP address? Online IP Checker',
			description:
				'Instantly check your public IP address, location, ISP, and browser details with our free online IP Checker. Fast, accurate, and no installation required.',
			keywords: 'IP checker',
			link: [{ rel: 'canonical', href: canonical('/what-is-my-ip/') }],
		},
		component: () => import('@/views/ipChecker.vue'),
	},
	{ path: '/vpn-meaning/', redirect: '/blog/vpn-meaning/' },
	{ path: '/activate-vpn-opera-browser/', redirect: '/blog/activate-vpn-opera-browser/' },
	{ path: '/activate-vpn-uc-browser/', redirect: '/blog/activate-vpn-uc-browser/' },
	{
		path: '/microsoft-security-update-breaks-vpn/',
		name: 'en-microsoft-security-update-breaks-vpn',
		meta: {
			appname: 'Secure VPN',
			guideSlug: 'microsoft-security-update-breaks-vpn',
			title: 'Microsoft Security Update Breaks VPN: Fix VPN Issues',
			description:
				'Microsoft security update breaks VPN connection? Learn why your VPN stopped working after Windows update and how to fix VPN issues quickly.',
			keywords: 'Microsoft security update VPN, VPN not working after Windows update, Secure VPN',
			link: [{ rel: 'canonical', href: canonical('/microsoft-security-update-breaks-vpn/') }],
		},
		component: () => import('@/views/guideArticle.vue'),
	},
	{
		path: '/which-free-vpn-works-with-netflix/',
		name: 'en-which-free-vpn-works-with-netflix',
		meta: {
			appname: 'Secure VPN',
			guideSlug: 'which-free-vpn-works-with-netflix',
			title: 'Which Free VPN Works With Netflix?',
			description:
				'Looking for a free VPN that works with Netflix? Compare the best free VPNs in 2026, including Proton VPN, PrivadoVPN, Windscribe, hide.me, and Secure VPN.',
			keywords: 'free VPN Netflix, Secure VPN',
			link: [{ rel: 'canonical', href: canonical('/which-free-vpn-works-with-netflix/') }],
		},
		component: () => import('@/views/guideArticle.vue'),
	},
	{
		path: '/are-free-vpns-safe-how-to-choose/',
		name: 'en-are-free-vpns-safe',
		meta: {
			appname: 'Secure VPN',
			guideSlug: 'are-free-vpns-safe-how-to-choose',
			title: 'Are Free VPNs Safe? How to Choose One Without Risking Your Privacy',
			description:
				'Learn how free VPNs really make money, which privacy risks to avoid, and the safest free VPNs recommended by security experts and Reddit users.',
			keywords: 'Secure VPN',
			link: [{ rel: 'canonical', href: canonical('/are-free-vpns-safe-how-to-choose/') }],
		},
		component: () => import('@/views/guideArticle.vue'),
	},
	{
		path: '/best-vpn-for-free-fire/',
		name: 'en-best-vpn-for-free-fire',
		meta: {
			appname: 'Secure VPN',
			guideSlug: 'best-vpn-for-free-fire',
			title: 'Best VPN for Free Fire (2026): Lower Ping, Better Privacy & Safer Gaming',
			description:
				'Looking for the best VPN for Free Fire? Learn when a VPN can help reduce ping, improve privacy on public Wi-Fi, and which free and paid VPNs are worth using in 2026.',
			keywords: 'Secure VPN',
			link: [{ rel: 'canonical', href: canonical('/best-vpn-for-free-fire/') }],
		},
		component: () => import('@/views/guideArticle.vue'),
	},
	{
		path: '/is-secure-vpn-safe/',
		name: 'en-is-secure-vpn-safe',
		meta: {
			appname: 'Secure VPN',
			guideSlug: 'is-secure-vpn-safe',
			title: 'Is Secure VPN Safe? Security, Privacy & Risks Explained (2026)',
			description:
				'Is Secure VPN safe to use? Learn about its security, privacy policy, encryption, permissions, and tips to protect your data before using Secure VPN.',
			keywords: 'Secure VPN',
			link: [{ rel: 'canonical', href: canonical('/is-secure-vpn-safe/') }],
		},
		component: () => import('@/views/guideArticle.vue'),
	},
	...locationRoutes,
]

export default function createRouter() {
	const router = new VueRouter({
		mode: 'history',
		routes: constRoutesPc,
		scrollBehavior(to, from, savedPosition) {
			if (savedPosition) {
				return savedPosition
			}
			return { x: 0, y: 0 }
		},
	})

	router.beforeEach((to, from, next) => {
		// 静态资源（如 sitemap.xml）不要自动补尾部斜杠
		const isStaticFile = /\.[a-z0-9]+$/i.test(to.path)
		if (to.path !== '/' && !to.path.endsWith('/') && !isStaticFile) {
			next({
				path: `${to.path}/`,
				query: to.query,
				hash: to.hash,
				replace: true,
			})
			return
		}
		next()
	})

	return router
}
